// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productLinesStyles } from "@tps/Overrides/Widgets/BrandDetails/BrandDetailsProductLines";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productLinesStyles.title = {
    variant: "h2",
    css: css`
        line-height: 26px;
        margin-bottom: 24px;
    `,
};

productLinesStyles.container = {
    css: css`
        border-top: 1px solid ${color("common.ui3")};
        padding-top: 32px;
        margin-bottom: 30px;
        position: relative;
    `,
};
productLinesStyles.productLineContainer = {
    gap: 22,
};

productLinesStyles.productLineItemRow = {
    width: [6, 3, 3, 3, 2.4] as any,
    css: css`
        margin-right: 20px;
        margin-bottom: 24px;
        display: flex;
        flex-direction: column;
        align-items: start;
    `,
};

productLinesStyles.innerProductLineContainer = {
    css: css`
        margin-bottom: 12px;
        max-width: 100%;
        height: 176px;
    `,
};

productLinesStyles.productLineImage = {
    width: "176px",
    height: "176px",
    css: css`
        img {
            height: auto;
        }
    `,
};

productLinesStyles.productLineNameLink = {
    color: "text.main",
    typographyProps: {
        weight: "bold",
        size: 16,
        css: css`
            overflow-wrap: break-word;
            word-wrap: break-word;
            line-height: 17px;
            text-align: center;
            width: 100%;
            max-width: 176px;
        `,
    },
    css: css`
        width: 100%;
    `,
};

productLinesStyles.viewAllButton = {
    typographyProps: {
        weight: "bold",
        size: 14,
        ellipsis: true,
        lineHeight: "16px",
    },
    css: css`
        background: none;
        position: absolute;
        left: 178px;
        top: 40px;
        color: ${color("text.link")};
        border: 0;
        padding: 0;
        font-weight: bold;
        min-height: auto;
        &:hover,
        &:focus {
            background: none;
        }
    `,
};
